export default __webpack_public_path__ + "e3622060a0d70dad7a9531616aa15e87.png";